import { render, staticRenderFns } from "./Detail.vue?vue&type=template&id=1f45a2ea&scoped=true&"
import script from "./Detail.vue?vue&type=script&lang=js&"
export * from "./Detail.vue?vue&type=script&lang=js&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&lang=css&"
import style1 from "./Detail.vue?vue&type=style&index=1&lang=css&"
import style2 from "./Detail.vue?vue&type=style&index=2&id=1f45a2ea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f45a2ea",
  null
  
)

export default component.exports